import { useNavigate } from 'react-router-dom';
import { T } from '@design/index';
import { WebEntryLayout } from './entryHelpers';

const loginCards = [
  {
    key: 'phone',
    title: 'Login with Phone',
    desc: 'Sign in using your phone number & OTP',
    accent: T.teal,
    route: '/patient/login/phone',
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#FFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.79 19.79 0 012.12 4.18 2 2 0 014.11 2h3a2 2 0 012 1.72" />
        <path d="M15.05 5A5 5 0 0119 8.95M15.05 1A9 9 0 0123 8.94" />
      </svg>
    ),
  },
  {
    key: 'email',
    title: 'Login with Email',
    desc: 'Sign in using your email address',
    accent: T.navy,
    route: '/patient/login/email',
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#FFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
        <polyline points="22,6 12,13 2,6" />
      </svg>
    ),
  },
  {
    key: 'google',
    title: 'Sign in with Google',
    desc: 'Google login integration pending',
    accent: '#6B7280',
    route: '/patient/login/google',
    icon: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#FFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <path d="M12 8v8M8 12h8" />
      </svg>
    ),
  },
];

export default function EntryChoiceScreen() {
  const navigate = useNavigate();

  return (
    <WebEntryLayout>
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '48px 28px 40px', fontFamily: T.font }}>
      <div style={{ fontSize: 22, fontWeight: 800, color: T.text, marginBottom: 4, textAlign: 'center', lineHeight: 1.3 }}>
        Welcome Back
      </div>
      <div style={{ fontSize: 13, color: T.textSec, marginBottom: 32, textAlign: 'center' }}>
        Sign in or create a new account
      </div>

      <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 14 }}>
        {loginCards.map((r) => (
          <div
            key={r.key}
            onClick={() => navigate(r.route)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 14,
              width: '100%',
              padding: '18px 16px',
              borderRadius: 18,
              border: `1.5px solid ${r.accent}30`,
              background: `${r.accent}08`,
              cursor: 'pointer',
              boxShadow: `0 4px 14px ${r.accent}1A`,
              boxSizing: 'border-box',
            }}
          >
            <div style={{ width: 48, height: 48, borderRadius: 14, background: `linear-gradient(135deg, ${r.accent}, ${T.overlap})`, display: 'grid', placeItems: 'center', flexShrink: 0 }}>
              {r.icon}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 14, fontWeight: 800, color: T.text }}>{r.title}</div>
              <div style={{ fontSize: 11, color: T.textSec, marginTop: 2 }}>{r.desc}</div>
            </div>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={r.accent} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 18l6-6-6-6" />
            </svg>
          </div>
        ))}
      </div>

      {/* Register link */}
      <div style={{ width: '100%', marginTop: 28 }}>
        <div style={{ fontSize: 9, fontWeight: 700, color: T.textTer, letterSpacing: '0.06em', textTransform: 'uppercase', textAlign: 'center', marginBottom: 12 }}>
          New to NeoHealthCard?
        </div>
        <button
          onClick={() => navigate('/patient/onboarding')}
          style={{
            width: '100%',
            padding: '14px 0',
            borderRadius: 14,
            border: `1.5px solid ${T.teal}`,
            background: 'transparent',
            color: T.teal,
            fontSize: 14,
            fontWeight: 700,
            fontFamily: T.font,
            cursor: 'pointer',
          }}
        >
          Register New Account
        </button>
      </div>

    </div>
    </WebEntryLayout>
  );
}
